"use strict";
export const ADD_NEW_CHAIN_URL = "https://integration-form.protofire.io";
